"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchServerConfigIfNeeded = exports.fetchServerInfoIfNeeded = exports.FETCH_SERVER_CONFIG = exports.FETCH_SERVER_INFO = void 0;
var utils_1 = require("../../utils");
exports.FETCH_SERVER_INFO = (0, utils_1.networkActionTypes)("FETCH_SERVER_INFO");
exports.FETCH_SERVER_CONFIG = (0, utils_1.networkActionTypes)("FETCH_SERVER_CONFIG");
var fetchServerInfo = (0, utils_1.networkAction)(exports.FETCH_SERVER_INFO, "/info");
exports.fetchServerInfoIfNeeded = (0, utils_1.makeIfNeededAction)(fetchServerInfo, "serverInfo");
var fetchServerConfig = (0, utils_1.networkAction)(exports.FETCH_SERVER_CONFIG, "/config");
exports.fetchServerConfigIfNeeded = (0, utils_1.makeIfNeededAction)(fetchServerConfig, "serverConfig");
